<template>
  <cds-icon
    :size="size"
    v-bind="$attrs"
    :class="[
      {
        [colors[color]]: color,
        [cursors[cursor]]: cursor,
        'tw-opacity-40 tw-cursor-not-allowed': disabled,
      },
    ]"
  />
</template>

<script setup lang="ts">
import { IconColors } from '@shared/models/types/ui/app-icon'

withDefaults(
  defineProps<{
    size?: string
    color?: IconColors
    disabled?: boolean
    cursor?: string
  }>(),
  {
    size: '24',
    color: 'inherit',
    cursor: 'default',
  }
)

const colors: Record<IconColors, string> = {
  primary: 'tw-text-dynamic-primary',
  accent: 'tw-text-blue-400',
  success: 'tw-text-green-500',
  secondary: 'tw-text-gray-3',
  black: 'tw-text-black',
  primaryBlack: 'tw-text-primary-black',
  error: 'tw-text-dynamic-danger',
  warning: 'tw-text-orange-500',
  white: 'tw-text-white',
  inherit: 'tw-text-inherit',
  disabled: 'tw-text-gray-400',
  none: '',
}

const cursors: Record<string, string> = {
  pointer: 'tw-cursor-pointer',
  notAllowed: 'tw-cursor-not-allowed',
  default: '',
}
</script>
